import React from 'react';
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Checkbox,
  Flex,
  Icon,
  Select,
  Switch,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import CommonPagination from 'components/commonPagination/CommonPagination';
import DeleteModal from 'components/popUpModel/DeleteModal';
import IsDeactivateModal from 'components/popUpModel/IsDeactivateModal';
import SyncDataModal from 'components/popUpModel/SyncDataModal';
import SyncDataLoader from 'components/wholePageLoader/SyncDataLoader';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useListState from 'hooks/useListState';
import {
  DeleteMerchnatData,
  MaintenanceMode,
  SyncDataMerchant,
  TemporaryCloseMerchant,
  ComingSoonMode,
  SyncMerchantSheet,
  BulkHideMerchants,
} from 'reactRedux/thunks/merchnatThunk/merchantThunk';
import CommonTable from '../../../components/commonTable/CommonTable';
import CommonSearch from 'components/commonSearchBar/CommonSearch';
import CommonTabSwitcher from 'components/commonTabSwitcher/CommonTabSwitcher';
import { sideBarRoutes } from 'utils/StaticData';
import {
  FaArchive,
  FaFileImport,
  FaFilePdf,
  FaPlus,
  FaStore,
  FaTimes,
  FaTrashRestore,
  FaUsersCog,
} from 'react-icons/fa';
import { ViewAdminUserData } from 'reactRedux/thunks/adminUserThunk/adminUserThunk';
import MerchantListModal from '../stationPages/MerchantListModal';
import InvoiceGenerationModal from './InvoiceGenerationModal';
import MerchantBulkUploadModal from './MerchantBulkUploadModal';
import { EditAdminUserData } from 'reactRedux/thunks/adminUserThunk/adminUserThunk';
import Swal from 'sweetalert2';
import { MerchantDataListPage } from 'reactRedux/thunks/merchnatThunk/merchantThunk';
import { PiPencil } from 'react-icons/pi';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { generateInvoiceValidationSchema } from 'utils/CommonValidation';
import { YearOptionsForInvoice } from 'utils/StaticData';
import {
  languageOptions,
  maintenanceFilterOptions,
  temporarilyClosedFilterOptions,
  comingSoonFilterOptions,
} from 'utils/StaticData';
import { regionLanguageConfig } from 'utils/StaticData';
import {
  DownloadSettlementsPDFBulk,
  SendSettlementsEmailBulk,
  GenerateBulkStore,
} from 'reactRedux/thunks/settlementsThunk/SettlementsThunk';
import Request from 'utils/Request';
import { MERCHANTNAMELIST } from 'utils/StaticApiEndpoints';
import useMerchantFilter from 'hooks/useMerchantFilter';

const MerchantList = () => {
  const navigate = useNavigate();
  const {
    params,
    setParam,
    setParams,
    debouncedParams,
    page,
    setPage,
    currentUrl,
  } = useListState({
    defaults: {
      search: '',
      limit: 10,
      inMaintenance: '',
      isTemporarilyClosed: '',
      isComingSoon: '',
      archivedView: '',
    },
    debounceKeys: ['search'],
  });
  const { adminDetails } = useSelector((state) => state.authSlice);
  const dispatch = useDispatch();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const currentYear = new Date().getFullYear();
  const { isPDFDownload, isEmailSending, isGenerating, invoiceJobProgress } =
    useSelector((state) => state.SettlementsSlice);
  const {
    isOpen: isMerchantModalOpen,
    onOpen: onMerchantModalOpen,
    onClose: onMerchantModalClose,
  } = useDisclosure();
  const {
    isOpen: isInvoiceModalOpen,
    onOpen: onInvoiceModalOpen,
    onClose: onInvoiceModalClose,
  } = useDisclosure();
  const {
    isOpen: isBulkUploadModalOpen,
    onOpen: onBulkUploadModalOpen,
    onClose: onBulkUploadModalClose,
  } = useDisclosure();
  const merchantDeleteRef = useRef(null);
  const merchantStatusRef = useRef({ id: null, isActive: null });
  const {
    listMerchants,
    isSyncLoading,
    isMerchantSheetLoading,
    isListlaoding,
    isMaintenanceLoading,
    isTemporaryCloseLoading,
    isComingSoonLoading,
    isBulkHideLoading,
  } = useSelector((state) => state.MerchantSlice);
  const [modalType, setModalType] = useState(null); // Track which modal to open
  const { viewAdminUserDetails } = useSelector((state) => state.AdminUserSlice);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  const [tempCloseModalOpen, setTempCloseModalOpen] = useState(false);
  const [isTempClosing, setIsTempClosing] = useState(false);
  const merchantTempCloseRef = useRef(null);
  const [comingSoonModalOpen, setComingSoonModalOpen] = useState(false);
  const [isEnablingComingSoon, setIsEnablingComingSoon] = useState(false);
  const merchantComingSoonRef = useRef(null);
  const [conflictFlag, setConflictFlag] = useState(null);
  const isHiddenView = params.archivedView === 'true';
  const [bulkHideModalOpen, setBulkHideModalOpen] = useState(false);
  const [bulkHideSelection, setBulkHideSelection] = useState([]);

  // State for merchant selection
  const [selectedMerchants, setSelectedMerchants] = useState([]);
  const [selectedMerchantName, setSelectedMerchantName] = useState('');
  const [isRemove, setIsRemove] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState('1');

  // Add new state to track success
  const [isSuccess, setIsSuccess] = useState(false);

  // States for modal merchants
  const [modalMerchants, setModalMerchants] = useState([]);

  const defaultYearOption = YearOptionsForInvoice.find(
    // eslint-disable-next-line eqeqeq
    (option) => option.label == currentYear,
  );

  const getDefaultLanguage = (regionId) => {
    const config = regionLanguageConfig.find((c) => c.regionId === regionId);
    const languageId = config ? config.languageId : 'en'; // Default to English
    return languageOptions.find((opt) => opt.id === languageId);
  };

  const {
    register,
    control,
    handleSubmit,
    watch,
    reset,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(generateInvoiceValidationSchema),
    defaultValues: {
      merchant: [],
      year: defaultYearOption || null,
      daysSelect: {
        id: 1,
        label: 'Quarters',
      },
      quarter: null,
      month: null,
      language: getDefaultLanguage(null) || {
        id: 'en',
        label: 'English',
      },
    },
  });

  // Initialize merchant filter hook for invoice modal
  const invoiceMerchantFilterHook = useMerchantFilter(
    watch('merchant') || [],
    (selectedMerchants) => {
      setValue('merchant', selectedMerchants);
    },
  );

  // const openDeleteModal = (merchantId) => {
  //   setModalType('delete');
  //   merchantDeleteRef.current = merchantId;
  // };

  const openSyncModal = () => {
    setModalType('sync');
  };

  const openStatusModal = (merchantId, currentStatus, row) => {
    const enabling = !currentStatus;
    setStatusModalOpen(true);
    setIsActivating(enabling);
    merchantStatusRef.current = { id: merchantId, isActive: enabling };
    if (enabling) {
      if (row?.isTemporarilyClosed) setConflictFlag('Temporarily Closed');
      else if (row?.isComingSoon) setConflictFlag('Coming Soon');
      else setConflictFlag(null);
    } else {
      setConflictFlag(null);
    }
  };

  const closeModal = () => {
    setModalType(null);
  };

  const closeStatusModal = () => {
    setStatusModalOpen(false);
  };

  const handleStatusChange = () => {
    const { id, isActive } = merchantStatusRef.current;
    dispatch(
      MaintenanceMode(id, { inMaintenance: isActive }, () => {
        closeStatusModal();
      }),
    );
  };

  const openTempCloseModal = (merchantId, currentStatus, row) => {
    const enabling = !currentStatus;
    setTempCloseModalOpen(true);
    setIsTempClosing(enabling);
    merchantTempCloseRef.current = { id: merchantId, isActive: enabling };
    if (enabling) {
      if (row?.inMaintenance) setConflictFlag('Maintenance');
      else if (row?.isComingSoon) setConflictFlag('Coming Soon');
      else setConflictFlag(null);
    } else {
      setConflictFlag(null);
    }
  };

  const closeTempCloseModal = () => setTempCloseModalOpen(false);

  const handleTempCloseChange = () => {
    const { id, isActive } = merchantTempCloseRef.current;
    dispatch(
      TemporaryCloseMerchant(id, { isTemporarilyClosed: isActive }, () => {
        closeTempCloseModal();
      }),
    );
  };

  const openComingSoonModal = (merchantId, currentStatus, row) => {
    const enabling = !currentStatus;
    setComingSoonModalOpen(true);
    setIsEnablingComingSoon(enabling);
    merchantComingSoonRef.current = { id: merchantId, isActive: enabling };
    if (enabling) {
      if (row?.inMaintenance) setConflictFlag('Maintenance');
      else if (row?.isTemporarilyClosed) setConflictFlag('Temporarily Closed');
      else setConflictFlag(null);
    } else {
      setConflictFlag(null);
    }
  };

  const closeComingSoonModal = () => setComingSoonModalOpen(false);

  const handleComingSoonChange = () => {
    const { id, isActive } = merchantComingSoonRef.current;
    dispatch(
      ComingSoonMode(id, { isComingSoon: isActive }, () => {
        closeComingSoonModal();
      }),
    );
  };

  const getMerchantList = useCallback(() => {
    const apiParams = {
      page: page,
      limit: params.limit || 10,
      search: debouncedParams.search,
      isHidden: params.archivedView === 'true',
    };
    if (params.inMaintenance !== '') {
      apiParams.inMaintenance = params.inMaintenance;
    }
    if (params.isTemporarilyClosed !== '') {
      apiParams.isTemporarilyClosed = params.isTemporarilyClosed;
    }
    if (params.isComingSoon !== '') {
      apiParams.isComingSoon = params.isComingSoon;
    }
    dispatch(MerchantDataListPage(apiParams));
  }, [
    dispatch,
    page,
    params.limit,
    debouncedParams.search,
    params.inMaintenance,
    params.isTemporarilyClosed,
    params.isComingSoon,
    params.archivedView,
  ]);

  const loadModalMerchants = async () => {
    try {
      // Lightweight endpoint returning only { merchantId, name, regionId } for
      // every merchant in one call — the dropdown filters client-side.
      const response = await Request.get(MERCHANTNAMELIST);
      if (response?.data) {
        setModalMerchants(response.data);
      }
    } catch (error) {
      // Handle error silently or show alert
    }
  };

  useEffect(() => {
    getMerchantList();
  }, [getMerchantList]);

  useEffect(() => {
    setBulkHideSelection([]);
  }, [params.archivedView]);

  const openBulkHideModal = (ids) => {
    setBulkHideSelection(ids);
    setBulkHideModalOpen(true);
  };

  const closeBulkHideModal = () => {
    setBulkHideModalOpen(false);
    setBulkHideSelection([]);
  };

  const handleBulkHideConfirm = () => {
    dispatch(
      BulkHideMerchants(
        { merchantIds: bulkHideSelection, isHidden: !isHiddenView },
        () => {
          closeBulkHideModal();
          getMerchantList();
        },
      ),
    );
  };

  useEffect(() => {
    if (isInvoiceModalOpen) {
      loadModalMerchants();
    }
  }, [isInvoiceModalOpen]);

  const columnHelper = createColumnHelper();
  const selectColumn = columnHelper.display({
    id: 'select',
    header: () => (
      <Checkbox
        isChecked={
          listMerchants?.list?.length > 0 &&
          listMerchants.list.every((m) =>
            bulkHideSelection.includes(m.merchantId),
          )
        }
        isIndeterminate={
          bulkHideSelection.length > 0 &&
          !listMerchants?.list?.every((m) =>
            bulkHideSelection.includes(m.merchantId),
          )
        }
        onChange={(e) => {
          const currentPageIds =
            listMerchants?.list?.map((m) => m.merchantId) || [];
          if (e.target.checked) {
            // Add current page IDs to existing selection (preserve other pages)
            setBulkHideSelection((prev) => [
              ...prev,
              ...currentPageIds.filter((id) => !prev.includes(id)),
            ]);
          } else {
            // Remove only current page IDs from selection
            setBulkHideSelection((prev) =>
              prev.filter((id) => !currentPageIds.includes(id)),
            );
          }
        }}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        isChecked={bulkHideSelection.includes(row.original.merchantId)}
        onChange={(e) => {
          if (e.target.checked) {
            setBulkHideSelection((prev) => [...prev, row.original.merchantId]);
          } else {
            setBulkHideSelection((prev) =>
              prev.filter((id) => id !== row.original.merchantId),
            );
          }
        }}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  });
  const columns = [
    columnHelper.accessor((row) => row?.merchantId, {
      id: 'merchantId',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Merchant Id
        </Text>
      ),
      cell: (info) => (
        <Link
          to={`/admin/merchants/details/${info?.row?.original?.merchantId}`}
          state={{ returnUrl: `/admin/merchants${currentUrl}` }}
          className="btn btn-primary rounded-2 p-1"
        >
          <Text
            color={textColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
            whiteSpace="nowrap"
          >
            {info.getValue()}
          </Text>
        </Link>
      ),
    }),
    columnHelper.accessor((row) => row?.name, {
      id: 'name',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Merchant
        </Text>
      ),
      cell: (info) => (
        <Text
          color={textColor}
          fontSize="sm"
          fontWeight="600"
          align="left"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          maxW="250px"
        >
          {info.getValue() ? info.getValue() : 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor((row) => row?.address, {
      id: 'address',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Address
        </Text>
      ),
      cell: (info) => {
        const value = info.getValue();

        return (
          <Flex align="left">
            <Text
              color={textColor}
              fontSize="sm"
              fontWeight="600"
              align="left"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              maxW="500px"
            >
              {value}
            </Text>
          </Flex>
        );
      },
    }),
    columnHelper.accessor((row) => row?.locationId, {
      id: 'locationId',
      header: () => (
        <Text
          justifyContent="space-between"
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Location Id
        </Text>
      ),
      cell: (info) => (
        <Text
          color={textColor}
          fontSize="sm"
          fontWeight="600"
          align="left"
          whiteSpace="nowrap"
          overflow={'hidden'}
          textOverflow={'ellipsis'}
        >
          {info.getValue()}
        </Text>
      ),
    }),
  ];

  const toggleColumns = [
    columnHelper.accessor((row) => row?.inMaintenance, {
      id: 'inMaintenance',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          MAINTENANCE
        </Text>
      ),
      cell: (row) => (
        <Flex className="no-navigate">
          {adminDetails?.role === sideBarRoutes?.Admin ||
          adminDetails?.role === sideBarRoutes?.Dealer ? (
            <Switch
              colorScheme="red"
              isChecked={row?.row?.original?.inMaintenance}
              onChange={() =>
                openStatusModal(
                  row?.row?.original?.merchantId,
                  row?.row?.original?.inMaintenance,
                  row?.row?.original,
                )
              }
            />
          ) : (
            <Text color="gray.600" fontSize="sm">
              {row?.row?.original?.inMaintenance ? 'Yes' : 'No'}
            </Text>
          )}
        </Flex>
      ),
    }),
    columnHelper.accessor((row) => row?.isTemporarilyClosed, {
      id: 'isTemporarilyClosed',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          TEMPORARILY CLOSE
        </Text>
      ),
      cell: (row) => (
        <Flex className="no-navigate">
          {adminDetails?.role === sideBarRoutes?.Admin ||
          adminDetails?.role === sideBarRoutes?.Dealer ? (
            <Switch
              colorScheme="orange"
              isChecked={row?.row?.original?.isTemporarilyClosed}
              onChange={() =>
                openTempCloseModal(
                  row?.row?.original?.merchantId,
                  row?.row?.original?.isTemporarilyClosed,
                  row?.row?.original,
                )
              }
            />
          ) : (
            <Text color="gray.600" fontSize="sm">
              {row?.row?.original?.isTemporarilyClosed ? 'Yes' : 'No'}
            </Text>
          )}
        </Flex>
      ),
    }),
    columnHelper.accessor((row) => row?.isComingSoon, {
      id: 'isComingSoon',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          COMING SOON
        </Text>
      ),
      cell: (row) => (
        <Flex className="no-navigate">
          {adminDetails?.role === sideBarRoutes?.Admin ||
          adminDetails?.role === sideBarRoutes?.Dealer ? (
            <Switch
              colorScheme="green"
              isChecked={row?.row?.original?.isComingSoon}
              onChange={() =>
                openComingSoonModal(
                  row?.row?.original?.merchantId,
                  row?.row?.original?.isComingSoon,
                  row?.row?.original,
                )
              }
            />
          ) : (
            <Text color="gray.600" fontSize="sm">
              {row?.row?.original?.isComingSoon ? 'Yes' : 'No'}
            </Text>
          )}
        </Flex>
      ),
    }),
  ];

  const action = [
    columnHelper.accessor((row) => row?.actions, {
      id: 'actions',
      header: () => (
        <Text
          justifyContent="space-between"
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          width="50px"
          whiteSpace="nowrap"
        >
          ACTION
        </Text>
      ),
      cell: (row) => (
        <Flex gap={'20px'}>
          <Link
            to={`/admin/merchants/edit/${row?.row?.original?.merchantId}`}
            className="btn btn-light rounded-3 p-1"
          >
            <PiPencil size={20} title="Edit" />
          </Link>
        </Flex>
      ),
    }),
  ];

  // When admin user details are loaded, set the selected merchants
  useEffect(() => {
    if (viewAdminUserDetails && isMerchantModalOpen) {
      if (
        viewAdminUserDetails.merchants &&
        viewAdminUserDetails.merchants.length > 0
      ) {
        const merchantIds = viewAdminUserDetails.merchants.map(
          (merchant) => merchant.merchantId,
        );
        setSelectedMerchants(merchantIds);
        const merchantNames = viewAdminUserDetails.merchants
          .map((merchant) => merchant.merchantName)
          .join(', ');
        setSelectedMerchantName(merchantNames);
      }
    }
  }, [viewAdminUserDetails, isMerchantModalOpen]);

  const handleOpenMerchantModal = () => {
    dispatch(ViewAdminUserData({ id: adminDetails?.id }));
    onMerchantModalOpen();
  };

  const handleMerchantSelectionSubmit = (merchantIds) => {
    const payload = {
      merchants: merchantIds.map((e) => ({ merchantId: e })),
    };

    // Call API to update the current admin user
    dispatch(
      EditAdminUserData(adminDetails?.id, payload, () => {
        setSelectedMerchants(merchantIds);
        Swal.fire({
          icon: 'success',
          text: 'Merchants successfully assigned',
        });
        onMerchantModalClose();
        getMerchantList();
        dispatch(ViewAdminUserData({ id: adminDetails?.id }));
      }),
    );
  };

  const handleGenerate = (type) => (_e) => {
    const selectedDays = watch('daysSelect')?.id;
    const selectedMerchants = watch('merchant') || [];
    const merchantsToUse =
      selectedMerchants.length === 0 ? modalMerchants : selectedMerchants;

    if (type === 'download') {
      const merchantIds = merchantsToUse
        .map((merchant) => merchant.merchantId)
        .join(',');
      const payload = {
        merchantIds,
        year: watch('year')?.label,
        ...(selectedDays === 1 && { quarter: watch('quarter')?.id }),
        ...(selectedDays === 2 && { month: watch('month')?.id }),
        language: watch('language')?.id,
      };
      dispatch(DownloadSettlementsPDFBulk(payload, () => setIsSuccess(true)));
    } else if (type === 'email') {
      const merchantIds = merchantsToUse
        .map((merchant) => merchant.merchantId)
        .join(',');
      const payload = {
        merchantIds,
        year: watch('year')?.label,
        ...(selectedDays === 1 && { quarter: watch('quarter')?.id }),
        ...(selectedDays === 2 && { month: watch('month')?.id }),
        language: watch('language')?.id,
      };
      dispatch(SendSettlementsEmailBulk(payload, () => setIsSuccess(true)));
    } else {
      const merchantIds = merchantsToUse
        .map((merchant) => merchant.merchantId)
        .join(',');
      const payload = {
        merchantIds,
        year: parseInt(watch('year')?.label),
        ...(selectedDays === 1 && { quarter: watch('quarter')?.id }),
        ...(selectedDays === 2 && { month: watch('month')?.id }),
        language: watch('language')?.id,
      };
      dispatch(GenerateBulkStore(payload, () => setIsSuccess(true)));
    }
  };

  // Update useEffect to close modal only on success
  useEffect(() => {
    if (isSuccess && !isPDFDownload && !isEmailSending && !isGenerating) {
      onInvoiceModalClose();
      reset();
      setIsSuccess(false);
    }
  }, [
    isPDFDownload,
    isEmailSending,
    isGenerating,
    isSuccess,
    onInvoiceModalClose,
    reset,
  ]);

  const watchedMerchant = watch('merchant');
  const watchedDaysSelect = watch('daysSelect');
  const watchedQuarter = watch('quarter');
  const watchedMonth = watch('month');

  useEffect(() => {
    if (isInvoiceModalOpen) {
      if (watchedMerchant && watchedMerchant.length > 0) {
        const firstMerchant = modalMerchants?.find(
          (m) => m.merchantId === watchedMerchant[0].merchantId,
        );
        if (firstMerchant) {
          setValue('language', getDefaultLanguage(firstMerchant.regionId));
        }
      }
    }
  }, [isInvoiceModalOpen, watchedMerchant, modalMerchants, setValue]);

  // Form setValue mock for MerchantListModal
  const setModalValue = (field, _value) => {
    if (field === 'merchantId') {
      handleMerchantSelectionSubmit(_value);
    }
  };

  const isFormIncomplete = useMemo(
    () =>
      (watchedDaysSelect?.id === 1 && !watchedQuarter) ||
      (watchedDaysSelect?.id === 2 && !watchedMonth),
    [watchedDaysSelect, watchedQuarter, watchedMonth],
  );

  // Helper function to determine if warning should be shown
  const shouldShowWarning = () => {
    const isAdmin = adminDetails?.role === sideBarRoutes?.Admin;
    const isSpainDealer =
      adminDetails?.role === sideBarRoutes?.Dealer &&
      adminDetails?.region?.regionId === 2;
    const isSpainSeller =
      adminDetails?.role === sideBarRoutes?.Seller &&
      adminDetails?.region?.regionId === 2;

    return isAdmin || isSpainDealer || isSpainSeller;
  };

  return (
    <>
      {isSyncLoading && adminDetails?.role === sideBarRoutes?.Admin && (
        <SyncDataLoader />
      )}
      <Box pt={{ base: '60px', md: '80px', xl: '80px' }}>
        {/* Archive / Active tab switcher — Admin only */}
        {adminDetails?.role === sideBarRoutes?.Admin && (
          <CommonTabSwitcher
            tabs={[
              { label: 'Active Merchants', icon: FaStore },
              { label: 'Archived', icon: FaArchive },
            ]}
            activeIndex={isHiddenView ? 1 : 0}
            onChange={(i) => setParam('archivedView', i === 1 ? 'true' : '')}
          />
        )}

        {/* Archived view banner */}
        {isHiddenView && adminDetails?.role === sideBarRoutes?.Admin && (
          <Alert status="warning" borderRadius="10px" mb={3} py={2}>
            <AlertIcon />
            <Text fontSize="sm" fontWeight="600">
              Archived merchants — these are hidden from the app. Restore to
              make them active again.
            </Text>
          </Alert>
        )}

        {/* Filters + Search + Actions toolbar */}
        <Flex flexWrap="wrap" align="flex-end" mb={3} gap="12px">
          <Box width={{ base: '100%', sm: 'auto' }}>
            <Text
              fontSize="xs"
              fontWeight="600"
              mb="1"
              color={params.inMaintenance !== '' ? 'green.500' : 'gray.400'}
            >
              Maintenance
            </Text>
            <Select
              value={params.inMaintenance}
              onChange={(e) => setParam('inMaintenance', e.target.value)}
              width={{ base: '100%', sm: '160px' }}
              bg="white"
              borderRadius="10px"
            >
              {maintenanceFilterOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Select>
          </Box>
          <Box width={{ base: '100%', sm: 'auto' }}>
            <Text
              fontSize="xs"
              fontWeight="600"
              mb="1"
              color={
                params.isTemporarilyClosed !== '' ? 'green.500' : 'gray.400'
              }
            >
              Temporarily Closed
            </Text>
            <Select
              value={params.isTemporarilyClosed}
              onChange={(e) => setParam('isTemporarilyClosed', e.target.value)}
              width={{ base: '100%', sm: '160px' }}
              bg="white"
              borderRadius="10px"
            >
              {temporarilyClosedFilterOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Select>
          </Box>
          <Box width={{ base: '100%', sm: 'auto' }}>
            <Text
              fontSize="xs"
              fontWeight="600"
              mb="1"
              color={params.isComingSoon !== '' ? 'green.500' : 'gray.400'}
            >
              Coming Soon
            </Text>
            <Select
              value={params.isComingSoon}
              onChange={(e) => setParam('isComingSoon', e.target.value)}
              width={{ base: '100%', sm: '160px' }}
              bg="white"
              borderRadius="10px"
            >
              {comingSoonFilterOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Select>
          </Box>
          <Box width={{ base: '100%', sm: 'auto' }}>
            <Text
              fontSize="xs"
              fontWeight="600"
              mb="1"
              color={params.search ? 'green.500' : 'gray.400'}
            >
              Search
            </Text>
            <CommonSearch
              search={params.search}
              setSearch={(val) => setParam('search', val)}
              setPage={setPage}
            />
          </Box>
          {adminDetails?.role === sideBarRoutes?.Seller && (
            <Button
              bg="#53EB95"
              color="primary"
              borderRadius="12px"
              _hover={{ bg: '#53EB95', opacity: 0.8 }}
              onClick={handleOpenMerchantModal}
              leftIcon={<Icon as={FaUsersCog} w="15px" h="15px" />}
              width={{ base: '100%', sm: 'auto' }}
            >
              Manage Merchant
            </Button>
          )}
          {adminDetails?.role === sideBarRoutes?.Admin && (
            <>
              <Button
                colorScheme="red"
                borderRadius="12px"
                onClick={() => openSyncModal()}
                width={{ base: '100%', sm: 'auto' }}
              >
                Sync Data
              </Button>
              <Button
                colorScheme="green"
                borderRadius="12px"
                isLoading={isMerchantSheetLoading}
                loadingText="Syncing..."
                onClick={() => dispatch(SyncMerchantSheet())}
                width={{ base: '100%', sm: 'auto' }}
              >
                Sync to Sheet
              </Button>
            </>
          )}
          {adminDetails?.role !== sideBarRoutes?.Merchant && (
            <Button
              bg="reviveOrange"
              color="white"
              borderRadius="12px"
              _hover={{ bg: 'reviveOrange', opacity: 0.8 }}
              leftIcon={<Icon as={FaPlus} w="15px" h="15px" />}
              onClick={() => navigate('/admin/merchants/add')}
              width={{ base: '100%', sm: 'auto' }}
            >
              Add Merchant
            </Button>
          )}
          {(adminDetails?.role === sideBarRoutes?.Admin ||
            adminDetails?.role === sideBarRoutes?.Dealer) && (
            <Button
              bg="reviveOrange"
              color="white"
              borderRadius="12px"
              _hover={{ bg: 'reviveOrange', opacity: 0.8 }}
              onClick={onBulkUploadModalOpen}
              width={{ base: '100%', sm: 'auto' }}
              leftIcon={<Icon as={FaFileImport} w="15px" h="15px" />}
            >
              Import Merchants
            </Button>
          )}
          {(adminDetails?.role === sideBarRoutes?.Admin ||
            adminDetails?.role === sideBarRoutes?.Dealer ||
            adminDetails?.role === sideBarRoutes?.Seller) && (
            <Button
              bg="reviveOrange"
              color="white"
              borderRadius="12px"
              _hover={{ bg: 'reviveOrange', opacity: 0.8 }}
              leftIcon={<Icon as={FaFilePdf} w="15px" h="15px" />}
              onClick={onInvoiceModalOpen}
              width={{ base: '100%', sm: 'auto' }}
            >
              Invoice Generation
            </Button>
          )}
        </Flex>
        {/* Bulk selection action bar — appears when rows are selected */}
        {adminDetails?.role === sideBarRoutes?.Admin &&
          bulkHideSelection.length > 0 && (
            <Flex
              align="center"
              justify="space-between"
              bg={isHiddenView ? 'green.50' : 'red.50'}
              border="1px solid"
              borderColor={isHiddenView ? 'green.200' : 'red.200'}
              borderRadius="10px"
              px={4}
              py={3}
              mb={3}
              flexWrap="wrap"
              gap={3}
            >
              <Flex align="center" gap={2}>
                <Icon
                  as={isHiddenView ? FaTrashRestore : FaArchive}
                  color={isHiddenView ? 'green.600' : 'red.500'}
                  w="14px"
                  h="14px"
                />
                <Text
                  fontSize="sm"
                  fontWeight="700"
                  color={isHiddenView ? 'green.700' : 'red.600'}
                >
                  {bulkHideSelection.length} merchant
                  {bulkHideSelection.length > 1 ? 's' : ''} selected
                </Text>
              </Flex>
              <Flex gap={2}>
                <Button
                  size="sm"
                  colorScheme={isHiddenView ? 'green' : 'red'}
                  borderRadius="8px"
                  leftIcon={
                    <Icon
                      as={isHiddenView ? FaTrashRestore : FaArchive}
                      w="12px"
                      h="12px"
                    />
                  }
                  onClick={() => openBulkHideModal(bulkHideSelection)}
                  isLoading={isBulkHideLoading}
                >
                  {isHiddenView ? 'Restore Selected' : 'Archive Selected'}
                </Button>
                <Button
                  size="sm"
                  variant="ghost"
                  borderRadius="8px"
                  leftIcon={<Icon as={FaTimes} w="12px" h="12px" />}
                  onClick={() => setBulkHideSelection([])}
                  color="gray.500"
                >
                  Clear
                </Button>
              </Flex>
            </Flex>
          )}

        <CommonTable
          columns={[
            ...(adminDetails?.role === sideBarRoutes?.Admin
              ? [selectColumn]
              : []),
            ...columns,
            ...toggleColumns,
            ...(adminDetails?.role === sideBarRoutes?.Admin ||
            adminDetails?.role === sideBarRoutes?.Dealer ||
            adminDetails?.role === sideBarRoutes?.Seller
              ? action
              : []),
          ]}
          data={listMerchants?.list || []}
          isLoading={isListlaoding}
          isLink={true}
          keyValue="merchantId"
          parentLink={'/admin/merchants/details'}
          rowclick={[
            'select',
            'actions',
            'inMaintenance',
            'isTemporarilyClosed',
            'isComingSoon',
          ]}
          dynamicWidth={{
            select: '50px',
            merchantId: '140px',
            name: '250px',
            address: '500px',
            locationId: '200px',
            inMaintenance: '140px',
            isTemporarilyClosed: '160px',
            isComingSoon: '140px',
            actions: '80px',
          }}
        />
        {/* {listMerchants?.total > 10 && ( */}
        <CommonPagination
          totalCount={listMerchants?.total}
          activePage={page}
          pageCount={Math.ceil(listMerchants?.total / listMerchants?.limit)}
          onPageChange={setPage}
          itemsPerPage={params.limit || 10}
          onItemsPerPageChange={(newLimit) => {
            setParams({ limit: newLimit, page: 1 });
          }}
        />
        {/* )} */}

        {modalType === 'delete' && (
          <DeleteModal
            isOpen={modalType === 'delete'}
            onClose={closeModal}
            title="Are you sure you want to delete this merchant?"
            SolidBTNText="Delete"
            onDelete={() => {
              dispatch(
                DeleteMerchnatData(merchantDeleteRef.current, {}, () => {
                  getMerchantList();
                  closeModal();
                }),
              );
            }}
            loader={isListlaoding}
          />
        )}

        {modalType === 'sync' && (
          <SyncDataModal
            isOpen={modalType === 'sync'}
            onClose={closeModal}
            title="Are you sure you want to sync data? This will sync merchant, station, and power bank data."
            SolidBTNText="Sync"
            onClick={() => {
              closeModal();
              dispatch(
                SyncDataMerchant(() => {
                  getMerchantList();
                }),
              );
            }}
            loader={isListlaoding}
          />
        )}

        {statusModalOpen && (
          <IsDeactivateModal
            isOpen={statusModalOpen}
            onClose={closeStatusModal}
            title={isActivating ? 'Deactivate Merchant' : 'Activate Merchant'}
            description={
              isActivating
                ? conflictFlag
                  ? `Switch to maintenance mode? This will also disable "${conflictFlag}".`
                  : 'Switch to maintenance mode?'
                : 'Exit maintenance mode?'
            }
            confirmText={isActivating ? 'Confirm' : 'Reactivate'}
            confirmColorScheme={isActivating ? 'red' : 'green'}
            onConfirm={handleStatusChange}
            isLoading={isMaintenanceLoading}
            isActivating={isActivating}
          />
        )}

        {tempCloseModalOpen && (
          <IsDeactivateModal
            isOpen={tempCloseModalOpen}
            onClose={closeTempCloseModal}
            title={
              isTempClosing ? 'Temporarily Close Merchant' : 'Reopen Merchant'
            }
            description={
              isTempClosing
                ? conflictFlag
                  ? `Temporarily close this merchant? This will also disable "${conflictFlag}".`
                  : 'Are you sure you want to temporarily close this merchant?'
                : 'Are you sure you want to reopen this merchant?'
            }
            confirmText={isTempClosing ? 'Confirm' : 'Reopen'}
            confirmColorScheme={isTempClosing ? 'orange' : 'green'}
            onConfirm={handleTempCloseChange}
            isLoading={isTemporaryCloseLoading}
            isActivating={!isTempClosing}
          />
        )}

        {comingSoonModalOpen && (
          <IsDeactivateModal
            isOpen={comingSoonModalOpen}
            onClose={closeComingSoonModal}
            title={
              isEnablingComingSoon
                ? 'Mark as Coming Soon'
                : 'Remove Coming Soon'
            }
            description={
              isEnablingComingSoon
                ? conflictFlag
                  ? `Mark as coming soon? This will also disable "${conflictFlag}".`
                  : 'Are you sure you want to mark this merchant as coming soon?'
                : 'Are you sure you want to remove the coming soon status?'
            }
            confirmText={isEnablingComingSoon ? 'Confirm' : 'Remove'}
            confirmColorScheme={isEnablingComingSoon ? 'green' : 'red'}
            onConfirm={handleComingSoonChange}
            isLoading={isComingSoonLoading}
            isActivating={isEnablingComingSoon}
          />
        )}

        {bulkHideModalOpen && (
          <IsDeactivateModal
            isOpen={bulkHideModalOpen}
            onClose={closeBulkHideModal}
            title={isHiddenView ? 'Restore Merchants' : 'Archive Merchants'}
            description={
              isHiddenView
                ? `Are you sure you want to restore ${bulkHideSelection.length} merchant(s)?`
                : `Are you sure you want to archive ${bulkHideSelection.length} merchant(s)?`
            }
            confirmText={isHiddenView ? 'Restore' : 'Archive'}
            confirmColorScheme={isHiddenView ? 'green' : 'red'}
            onConfirm={handleBulkHideConfirm}
            isLoading={isBulkHideLoading}
            isActivating={!isHiddenView}
          />
        )}

        {adminDetails?.role === sideBarRoutes?.Seller && (
          <MerchantListModal
            isOpen={isMerchantModalOpen}
            onClose={onMerchantModalClose}
            setSelectedMerchants={setSelectedMerchants}
            setSelectedMerchantName={setSelectedMerchantName}
            setValue={setModalValue}
            roleId={sideBarRoutes.Seller}
            sellerId={adminDetails?.id}
            isRemove={isRemove}
            setIsRemove={setIsRemove}
            currentSelectedMerchants={selectedMerchants}
            currentSelectedMerchantNames={selectedMerchantName}
            selectedRegion={selectedRegion}
            setSelectedRegion={setSelectedRegion}
            adminDetails={adminDetails}
            selfAssign="true"
          />
        )}

        <MerchantBulkUploadModal
          isOpen={isBulkUploadModalOpen}
          onClose={onBulkUploadModalClose}
        />
        <InvoiceGenerationModal
          isOpen={isInvoiceModalOpen}
          onClose={onInvoiceModalClose}
          handleSubmit={handleSubmit}
          register={register}
          control={control}
          watch={watch}
          reset={reset}
          clearErrors={clearErrors}
          setValue={setValue}
          errors={errors}
          invoiceMerchantFilterHook={invoiceMerchantFilterHook}
          modalMerchants={modalMerchants}
          showWarning={shouldShowWarning()}
          handleGenerate={handleGenerate}
          isPDFDownload={isPDFDownload}
          isEmailSending={isEmailSending}
          isGenerating={isGenerating}
          isFormIncomplete={isFormIncomplete}
          invoiceJobProgress={invoiceJobProgress}
        />
      </Box>
    </>
  );
};

export default MerchantList;
